import { AttachmentFullViewState } from 'owa-attachment-full-data';
import getAttachmentFullViewStateById from 'owa-attachment-well-data/lib/utils/getAttachmentFullViewStateById';
import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import { getAttachmentWellViewStateByItemIdHelper } from '../utils/getAttachmentWellViewStateByItemIdHelper';

export default function tryGetAttachmentFullViewStateByIdForConversationView(
    conversationId: string,
    attachmentId: ClientAttachmentId,
    itemId: ClientItemId
): AttachmentFullViewState {
    if (!itemId) {
        return null;
    }

    // search for the attachment on attachment well level
    const attachmentWellViewState = getAttachmentWellViewStateByItemIdHelper.run(
        conversationId,
        itemId.Id
    );
    if (!!attachmentWellViewState) {
        const attachmentFullViewState = getAttachmentFullViewStateById(
            attachmentWellViewState,
            attachmentId
        );
        if (!!attachmentFullViewState) {
            return attachmentFullViewState;
        }
    }

    return null;
}
